export default "__VITE_ASSET__Cm9JnBac__"